import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const loginConfig: LoginPageConfig = {
  theme: {
    facebookBlue: '#1877F2',
    googleBlue: '#4285F4',
    appleDark: '#402A33',
    inputBorder: '#F5E4EA',
  },
  resources: {
    loginBg: '/images/novelyn/login-bg.svg',
    logo: '/images/novelyn/logo.jpg',
    novel: '/images/novelyn/title-white.svg',
    facebookIcon: '/images/novelyn/social-facebook.svg',
    googleIcon: '/images/novelyn/social-google.svg',
    appleIcon: '/images/novelyn/social-apple.svg',
    emailIcon: '/images/novelyn/social-email.svg',
    emailCodeIcon: '/images/novelyn/social-code.svg',
  },
  texts: reactive(loginCommonConfig.texts),
}
